import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { Dropdown } from "../../editor/Dropdown";
import { ElementGroup, ElementLabel } from './components/BaseElements';
export const StartActActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.property_act")), /*#__PURE__*/React.createElement(Dropdown, {
    value: action.act,
    onChange: ({
      target
    }) => action.setAct(target.value)
  }, [2, 3, 4, 5].map(amount => /*#__PURE__*/React.createElement("option", {
    key: amount,
    value: amount
  }, amount))));
});